import { useNavigate } from "react-router-dom";
import styles from "./CursoCard.module.css";
import { useState } from "react";
import MailAuthCurso from "../auth/MailAuthCurso";

interface CircleCardProps {
  title: string;
  imageSrc: string;
  idCurso: number;
  setCursoToRenderById: (id: number) => void;
}

const CursoCard: React.FC<CircleCardProps> = ({ title, imageSrc, idCurso, setCursoToRenderById }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCardClick = () => setIsModalOpen(true);

  const handleLoginSuccess = () => {
    setIsModalOpen(false);
    setCursoToRenderById(idCurso);
  };

  const handleClose = () => {
    setIsModalOpen(false)
  }

  return (
    <>
    <div className={styles.card}>
      {/* Contenedor de la imagen e ilustración */}
      <div className={styles.cardImageContainer}>
        <img 
            src={imageSrc} 
            alt={title} 
            className={styles.cardImage} 
            onClick={handleCardClick}
        />
      </div>
      {/* Pie de la tarjeta */}
      <div className={styles.cardFooter}>
        <span>{title}</span>
      </div>
    </div>

    {/* EL MODAL */}
      <MailAuthCurso 
        isOpen={isModalOpen} 
        onClose={handleClose}
        onSuccess={handleLoginSuccess}
        idCurso={idCurso}
      />
    </>
    
  );
};

export default CursoCard 